export default __webpack_public_path__ + "static/media/Bootstrap.6bd21855.png";